import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios';
import API_URL from "../../ApiUrl/ApiUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ContactList = () => {

  const [bookings, setBookings] = useState([]);

  // fetchBookings
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await axios.get(`${API_URL}/bookings`);
        console.log(response.data)
        setBookings(response.data);
      } catch (error) {
        console.error('Error fetching bookings:', error);
      }
    };

    fetchBookings();
  }, [])

  // HandleDelete
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this Contact ?')) {
      try {
        const response = await axios.delete(`${API_URL}/booking/${id}`);
        console.log('Delete response:', response);
        
        setBookings(bookings.filter((booking) => booking._id !== id));
        toast.error("Contact Delete Successfully !",{
          position:"top-center"
        })
         
      } catch (error) {
        console.error('Error deleting booking:', error);
        alert('Failed to delete booking.');
      }
    }
  };
  return (
  <>
    <ToastContainer/>
    <div className="content-wrapper pb-2 mb-0">
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3 className="m-0 text-dark">Contact List</h3>
          </div>
          {/* /.col */}
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Contact List</li>
            </ol>
          </div>
          {/* /.col */}
        </div>
        {/* /.row */}
      </div>
      {/* /.container-fluid */}
    </div>
    {/* Main content */}
    <section className="content">
    <div className="container-fluid">
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table id="custtbl" className="table card-table table-vcenter">
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr className="bookingtable">
                  <th className="w-1">S. No.</th>
                  <th className="w-1">First Name</th>
                  <th>Last Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Vehicle</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className="bookingtable" style={{ whiteSpace: "nowrap" }}>
                {bookings.length > 0 ? (
                  bookings.map((booking, index) => (
                    <tr key={booking._id}>
                      <td>{index + 1}</td>
                      <td>{booking.first_name}</td>
                      <td>{booking.last_name}</td>
                      <td>{booking.phone_number}</td>
                      <td>{booking.email}</td>
                      <td>{booking.address}</td>
                      <td>{new Date(booking.start_date).toLocaleDateString()}</td>
                      <td>{new Date(booking.end_date).toLocaleDateString()}</td>
                      <td>{booking.vehicle_type}</td>
                      <td>
                      <a className="icon text-danger"   onClick={() => handleDelete(booking._id)}>
                          <i className="fa fa-trash" />
                        </a>  
                       
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">No bookings available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </section>
 
 {/* pagination */}
 <nav aria-label="Page navigation example">
  <ul className="pagination mt-4 float-end">
    <li className="page-item">
      <a className="page-link" href="#">
        Previous
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        1
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        2
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        3
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        Next
      </a>
    </li>
  </ul>
</nav>
  </div>
  </>
  )
}

export default ContactList